
/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:33:58
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-12 16:51:43
 */
import req from "@/utils/request";

export const getTemplateList = (params) => req.post("/site-service/m/site/template/list", params);
export const addColumn = (params) => req.post("/site-service/m/site/column/addColumn", params);
export const tree = (params) => req.post("/site-service/m/site/column/tree", params);
export const listPage = (params) => req.post("/site-service/m/model/listPage", params);
export const detail = (params) => req.post("/site-service/m/site/column/detail", params);
export const deleteFn = (params) => req.post("/site-service/m/site/column/delete", params);
export const updateSort = (params) => req.post("/site-service/m/site/column/updateSort", params);
export const importTree = (params) => req.post("/site-service/m/site/column/importTree", params);
export const getListByParentId = (params) => req.post("/site-service/m/site/column/getListByParentId", params);
export const importColumnByPidList = (params) => req.post("/site-service/m/site/column/importColumnByPidList", params);